<template>
    <div class="prepay">
        <div style="height:50px;line-height:50px;" v-if="userBook">
            <span style="font-size: 14px;color: rgba(40, 43, 53, 0.4);margin-left:20px">我的余额：</span>
            <span style="font-size: 18px;color: #ff9236;">{{userBook.bookBalanceY}} RMB</span>
        </div>
        <div>
            <table>
                <tr class="th">
                    <td>时间</td>
                    <td>变动金额</td>
                    <td>详情</td>
                </tr>
                <tbody>
                    <tr v-for="(item, index) in userBookRecord.list" :key="index">
                        <td>{{item.changeTime}}</td>
                        <td>{{item.changeValueY}}</td>
                        <td>{{item.notes}}</td>
                    </tr>
                </tbody>
            </table>
            <div
                class="table-empty"
                v-if="!userBookRecord || !userBookRecord.list || (userBookRecord.list && userBookRecord.list.length === 0)"
            >
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next,total"
                :total="userBookRecord.count"
                :page-size="userBookRecord.pageSize"
                :current-page="userBookRecord.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/user';

export default {
    name: 'prepay',
    data() {
        return {
            userBookRecord: {
                list: [],
            },
            userBook: null,
        };
    },
    methods: {
        handleCurrentChange(page) {
            this.getUserBookRecord(page);
        },
        getUserBookRecord(page = 1) {
            apis.getUserBookRecord('CASH', page).then(res => {
                this.userBookRecord = res;
            });
        },
        getUserBook() {
            apis.getUserBook('CASH').then(res => {
                this.userBook = res;
            });
        },
    },
    mounted() {
        this.getUserBook();
        this.getUserBookRecord();
    },
};
</script>

<style lang="less" scoped>
</style>